<div class="listing-content-section listing-name">
  <div>
    <h2 [innerHTML]="listing?.name"></h2>
    <div class="div-block-35">
      <div class="location">
        {{ listing?.displayLocation ? listing.displayLocation() : '' }}
      </div>
    </div>
  </div>
  <curbnturf-user-image [user]="listing?.user"> </curbnturf-user-image>
</div>
